// Match the visible provider frame's documented 44px height on both platforms.
export const fundingApplePayButtonSettings = {
    height: '44px',
    borderRadius: '8px',
    style: 'white',
    type: 'pay',
};
